import { Middleware } from '@/api/generated/fetch-client';
import {
  BadRequestError,
  ConflictError,
  GoneError,
  NotFoundError,
  ServiceUnavailableError,
  TooManyRequestsError,
} from '@/types/errors';

export const responseStatusHandler: Middleware = {
  async post(context) {
    const status = context.response.status;
    switch (status) {
      case 400: {
        throw new BadRequestError();
      }
      case 404: {
        throw new NotFoundError();
      }
      case 409: {
        throw new ConflictError();
      }
      case 410: {
        throw new GoneError();
      }
      case 429: {
        throw new TooManyRequestsError();
      }
      case 500: {
        throw new ServiceUnavailableError();
      }
      // No default
    }
  },
};
